<a [href]="href" target="_blank" rel="noopener">{{value}}</a>